<template>
	<div  v-loading="loading">
		<el-dialog  title="订单详情" :visible.sync="dialogVisible" @close="close" :fullscreen="true" top="30vh" >
			<div>
				<el-divider content-position="left">基础信息</el-divider>
				<el-form label-width="80px">
					<el-row>
						<el-col :span="8">
							<el-form-item label="详细地址">
							    <el-input v-model="form.address" style="width: 80%;"></el-input>
							</el-form-item>
						</el-col>
						<el-col :span="8">
							<el-form-item label="联系人">
							    <el-input v-model="form.link_name"  style="width: 80%;"></el-input>
							</el-form-item>
						</el-col>
						<el-col :span="8">
							<el-form-item label="联系电话">
							    <el-input v-model="form.link_mobile"  style="width: 80%;"></el-input>
							</el-form-item>
						</el-col>
						<el-col :span="8">
							<el-form-item label="付款方式">
							    <el-input v-model="form.pay"  style="width: 80%;"></el-input>
							</el-form-item>
						</el-col>
						<el-col :span="8">
							<el-form-item label="">
							   <el-button @click="tijiao">保 存</el-button>
							</el-form-item>
						</el-col>
					</el-row>
				</el-form>
				
				<el-divider content-position="left">订单信息</el-divider>
				<el-form label-width="80px">
					<el-row>
						<el-col :span="12">
							<el-form-item label="备注">
							    <el-input v-model="order_form.yh_remark"  style="width: 80%;" placeholder="订单金额备注"></el-input>
							</el-form-item>
						</el-col>
						<el-col :span="12">
							<el-form-item label="金额">
								<el-input placeholder="金额" type="number"  v-model="order_form.yh_money_bl" class="input-with-select">
									<template slot="prepend">总金额:{{count_price}}</template>
									<el-select v-model="order_form.yh_money_fh"  slot="prepend" 
									style="width: 80px;margin-left: 20px;	" placeholder="符号">
									  <el-option label="+" value="+"></el-option>
									  <el-option label="-" value="-"></el-option>
									  <el-option label="*" value="*"></el-option>
									  <el-option label="/" value="/"></el-option>
									</el-select>
									<!-- <template slot="append">= {{num_money}}</template> -->
								</el-input>
							</el-form-item>
						</el-col>
					</el-row>
					<el-row>
						<el-col :span="12">
							<el-form-item label="备注">
							    <el-input v-model="order_form.yh_remark1"  style="width: 80%;" placeholder="订单金额备注"></el-input>
							</el-form-item>
						</el-col>
						<el-col :span="12">
							<el-form-item label="金额">
								<el-input placeholder="金额" type="number"  v-model="order_form.yh_money_bl1" class="input-with-select">
									<template slot="prepend">总金额:{{count_price}}</template>
									<el-select v-model="order_form.yh_money_fh1"  slot="prepend" 
									style="width: 80px;margin-left: 20px;	" placeholder="符号">
									  <el-option label="+" value="+"></el-option>
									  <el-option label="-" value="-"></el-option>
									  <el-option label="*" value="*"></el-option>
									  <el-option label="/" value="/"></el-option>
									</el-select>
									<!-- <template slot="append">= {{num_money}}</template> -->
								</el-input>
							</el-form-item>
						</el-col>
					</el-row>
					<el-row>
						<el-col :span="12">
							<el-form-item label="">
							   <el-button @click="money_tijiao">保 存</el-button>
							</el-form-item>
						</el-col>
					</el-row>
				</el-form>
				
				<el-divider content-position="left">商品信息</el-divider>
				<div class="table">
					<el-table border :data="tableData" row-key="uuid" style="width: 95%;margin-left: 2.5%;" >
						<el-table-column label="商品缩略图" prop="img">
							<template v-slot="scope">
								<img :src="scope.row.img" style="width: 120px;height: 120px;"/>
							</template>
						</el-table-column>
						<el-table-column label="商品名" prop="name">
						</el-table-column>
						<el-table-column label="规格" prop="norms_name">
						</el-table-column>
						<el-table-column label="数量" prop="goods_num">
							<template v-slot="scope">
								<el-input-number v-model="scope.row.goods_num" @change="GoodsNumEdit(scope.row)" :min="1"  ></el-input-number>
							</template>
						</el-table-column>
						<el-table-column label="单价" prop="price">
							<template v-slot="scope">
								￥{{scope.row.price}}
							</template>
						</el-table-column>
						<el-table-column label="总金额" prop="price">
							<template v-slot="scope">
								<span style="color: red;">￥{{scope.row.count_price}}</span>
							</template>
						</el-table-column>
						<el-table-column label="备注" prop="order">
							<template v-slot="scope">
								<el-input v-model="scope.row.order" placeholder="请输入内容"></el-input>
							</template>
						</el-table-column>
						<el-table-column align="center" width="200">
						  <template slot-scope="scope">
							<el-button size="mini"
							    @click="handleEdit(scope.$index, scope.row)" type="primary"><i class="el-icon-edit"></i>保存</el-button>
							<el-button size="mini"
								@click="handleDelete(scope.$index, scope.row)" type="danger"><i class="el-icon-edit"></i>删除</el-button>
						  </template>
						</el-table-column>
					  </el-table>
				</div>
			</div>
			
			<div style="height:30px"></div>
			<div style="height: 30px;text-align: center;">
				<el-button @click="close">关 闭</el-button>
			</div>
		</el-dialog>
	</div>
</template>
<script>
export default{
	name:'Edit',
	props:{
		id:String,
		type:String
	},
	data(){
		return {
			dialogVisible:true,
			data:[],
			loading: false,
			search:{
				order_id:"",
			},
			form:{
				address:"",
				link_name:"",
				link_mobile:"",
				pay:"",
			},
			order_form:{
				uuid:"",
				yh_remark:"",
				yh_money_fh:"",
				yh_money_bl:"",
				yh_remark1:"",
				yh_money_fh1:"",
				yh_money_bl1:"",
			},
			num_money:"",
			tableData:[],
			headerObj:{
				token:sessionStorage.getItem("token")
			},
			count_price:"",
			
		}
	},
	methods:{
		isNumber(val){
		    var regPos = /^\d+(\.\d+)?$/; //非负浮点数
		    var regNeg = /^(-(([0-9]+\.[0-9]*[1-9][0-9]*)|([0-9]*[1-9][0-9]*\.[0-9]+)|([0-9]*[1-9][0-9]*)))$/; //负浮点数
		    if(regPos.test(val) && regNeg.test(val)){
		        return true;
		    }else{
		        return false;
		    }
		},
		changeMoney(){
			if(this.order_form.yh_money_fh=="" || this.order_form.yh_money_bl=="") return;
			if(this.isNumber(this.order_form.yh_money_bl)){
				this.$error_text("请输入数字",this);
				return;
			}
			var money=eval(this.count_price+this.order_form.yh_money_fh+this.order_form.yh_money_bl).toFixed(2);
			this.num_money=money;
		},
		async handleDelete(index, row) {
			var self=this;
			this.$confirm('删除该数据, 是否继续?', '提示', {confirmButtonText: '确定',cancelButtonText: '取消',type: 'warning'}).then(() => {
				var url="/index/OrderGoods/OrderGoodsDelete";
				self.$post(url,{"uuid":row.uuid}).then(function(res){
					if(res.errCode=="1"){
						self.$success(res,self);
						self.SelectSearch()
					}else{
						self.$error(res,self);
					}
				})
			});
		},
		async SelectSearch(){
			var res=await this.$get("/index/OrderGoods/GetList",{"order_id":this.search.order_id})
			this.tableData=res.result.data;
		},
		async handleEdit(index,row){
			var url="/index/OrderGoods/Edit";
			var res=await this.$post(url,row)
			if(res.errCode=="0"){
				this.$error(res,this);
				return;
			}
			this.$success(res,this);
			// this.GetInfo();
		},
		GoodsNumEdit(row){
			if(row.goods_num==undefined){
				row.goods_num=1;
			}
			row.count_price=(row.goods_num*row.price).toFixed(2);
		},
		close(){
			this.dialogVisible=false
			this.$emit("close")
		},
		handleClick(tab, event){
		},
		async GetInfo(){
			var res=await this.$get("/index/OrderGoods/GetList",{"order_id":this.search.order_id})
			this.count_price=res.result.count_price;
			this.tableData=res.result.data;
			var res=await this.$get("/index/Order/Find",{"uuid":this.search.order_id})
			this.form={
				"address":res.result['address'],
				"link_name":res.result['link_name'],
				"link_mobile":res.result['link_mobile'],
				"pay":res.result['pay'],
				"uuid":res.result['uuid'],
			};
			this.order_form={
				"yh_remark":res.result['yh_remark'],
				"yh_money_fh":res.result['yh_money_fh'],
				"yh_money_bl":res.result['yh_money_bl'],
				"yh_remark1":res.result['yh_remark1'],
				"yh_money_fh1":res.result['yh_money_fh1'],
				"yh_money_bl1":res.result['yh_money_bl1'],
				"uuid":res.result['uuid'],
			};
			this.changeMoney();
		},
		async tijiao(){
			var url="/index/Order/Edit";
			var res=await this.$post(url,this.form)
			this.$success(res,this);
		},
		async money_tijiao(){
			var url="/index/Order/MoneyEdit";
			var res=await this.$post(url,this.order_form)
			this.$success(res,this);
		}
	},
	mounted(){
		if(this.id!=""){
			this.search.order_id=this.id
			this.GetInfo();
		} 
	}
}
</script>
<style scoped="scoped">
	/deep/ .el-dialog.is-fullscreen{
		margin-top:50px;
	}
	div{
		text-align: left;
	}
	.text{
		width: 80%;
	}
</style>
<style>
	 .avatar-uploader .el-upload {
	    border: 1px dashed #d9d9d9;
	    border-radius: 6px;
	    cursor: pointer;
	    position: relative;
	    overflow: hidden;
	  }
	  .avatar-uploader .el-upload:hover {
	    border-color: #409EFF;
	  }
	  .avatar-uploader-icon {
	    font-size: 28px;
	    color: #8c939d;
	    width: 178px;
	    height: 178px;
	    line-height: 178px;
	    text-align: center;
	  }
	  .avatar {
	    width: 178px;
	    height: 178px;
	    display: block;
	  }
	.zZindex {
	    z-index:9999 !important;
	}
</style>
